import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import "./Blog.css";

function SoldOutProductsRestock() {
  return (
    <>
      <SEO />
      <motion.div
        className="blog-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <article className="blog-article">
          <header className="blog-header">
            <h1>Boost Your Sales with Shopify Restock Alert Apps: Wave Notify and More</h1>
            <p className="blog-meta">
              Published: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </header>

          <div className="blog-content">
            <section className="blog-section">
              <p style={{ fontSize: '1.2rem', lineHeight: '1.8', marginBottom: '2rem' }}>
                In the competitive ecommerce landscape, keeping customers informed and engaged is crucial. One key way to do this is with restock alert apps, which notify customers when out-of-stock products are back in inventory. This not only helps in retaining interested customers but also prevents lost sales.
              </p>
            </section>

            <section className="blog-section">
              <h2>Top Apps for Boost Solutions</h2>
              
              
            <div className="app-feature-box" style={{ marginBottom: '2rem', padding: '1.5rem', background: 'rgba(0, 173, 238, 0.1)', borderRadius: '12px', border: '2px solid rgba(0, 173, 238, 0.3)' }}>
              <h3 style={{ color: '#00adee', fontSize: '1.8rem', marginBottom: '1rem' }}>
                1. Wave Notify ⭐ Featured
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1rem' }}>
                Wave Notify is a powerful automated back-in-stock notification app for Shopify stores. It captures customer emails on sold-out products and sends alerts when inventory is restored. It also creates Shopify customers, tags them, and builds segments for email campaigns.
              </p>
              <div style={{ marginBottom: '1rem' }}>
                <strong style={{ color: '#fff' }}>Key Features:</strong>
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>Automatic form display</li>
                  <li>Email notifications</li>
                  <li>Customer creation</li>
                  <li>Shopify Email integration</li>
                  <li>Form customizer</li>
                  <li>Analytics dashboard</li>
                </ul>
              </div>
              <p style={{ marginBottom: '1rem' }}>
                <strong style={{ color: '#fff' }}>Pricing:</strong> <span style={{ color: '#00adee' }}>Free plan: 5 notifications/month. Starter: $4.99/month (500 notifications). Pro: $9.99/month (1,000 notifications). Elite: $14.99/month (unlimited)</span>
              </p>
              <p style={{ fontStyle: 'italic', color: '#ccc' }}>Wave Notify offers a comprehensive solution to managing out-of-stock scenarios. Its automatic email notifications help keep customers engaged, while the analytics dashboard makes tracking performance a breeze.</p>
              <a 
                href="https://apps.shopify.com/wave-notify" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-block', 
                  marginTop: '1rem', 
                  padding: '0.75rem 1.5rem', 
                  background: 'linear-gradient(135deg, #00adee, #8a2be2)', 
                  color: '#fff', 
                  borderRadius: '8px', 
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
              >
                View on Shopify App Store →
              </a>
            </div>
              
              
            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'rgba(255, 255, 255, 0.04)', borderRadius: '12px' }}>
              <h3 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '0.75rem' }}>
                2. Back in Stock: Customer Alerts
              </h3>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
                This app allows customers to sign up for back in stock notifications, automatically alerting them when products are available again.
              </p>
              
              <ul style={{ marginTop: '0.5rem' }}>
                <li>Instant notifications</li>
                <li>Easy setup</li>
              </ul>
            </div>

            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'rgba(255, 255, 255, 0.04)', borderRadius: '12px' }}>
              <h3 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '0.75rem' }}>
                3. Restocked Alerts
              </h3>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
                Restocked Alerts offers customizable email notifications and advanced analytics to help you understand customer preferences better.
              </p>
              
              <ul style={{ marginTop: '0.5rem' }}>
                <li>Customizable emails</li>
                <li>Advanced analytics</li>
              </ul>
            </div>

            <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'rgba(255, 255, 255, 0.04)', borderRadius: '12px' }}>
              <h3 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '0.75rem' }}>
                4. Stockbot
              </h3>
              <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
                Stockbot simplifies stock management by sending restock alerts and provides insight into inventory levels.
              </p>
              
              <ul style={{ marginTop: '0.5rem' }}>
                <li>Restock alerts</li>
                <li>Inventory insights</li>
              </ul>
            </div>
            </section>

            <section className="blog-section">
              <h2>Why These Apps Matter</h2>
              <p>
                These restock alert apps are essential tools for ecommerce merchants. They help prevent lost sales by keeping customers informed about product availability while enhancing customer engagement. Additionally, these apps provide valuable insights into customer behavior and preferences, which can be leveraged to improve marketing strategies and boost sales.
              </p>
            </section>

            <section className="blog-section">
              <h2>Conclusion</h2>
              <p>
                In conclusion, restock alert apps like Wave Notify and others are invaluable tools for Shopify merchants. They not only prevent lost sales but also improve customer retention and engagement. Don't let an out-of-stock status deter your sales; try out these apps today and give your customers the best shopping experience. Click here to learn more about Wave Notify and start your free trial.
              </p>
              <p style={{ marginTop: '1.5rem' }}>
                <strong>Ready to get started?</strong> Check out <Link to="/wavenotify" style={{ color: '#00adee' }}>Wave Notify</Link> and <Link to="/wavesync" style={{ color: '#00adee' }}>Wave Sync</Link> on the Shopify App Store, or <Link to="/contact" style={{ color: '#00adee' }}>contact us</Link> for personalized recommendations.
              </p>
            </section>
          </div>
        </article>
      </motion.div>
    </>
  );
}

export default SoldOutProductsRestock;
